import { Component, inject, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { GreenHomeModel, GreenHousingFilterModel } from "./search-filter-green-housing.model";
import { EVToggleComponent, EVToggleStyle } from "src/app/shared-components/ev-toggle/toggle.component";
import { EvTooltipImgModule } from "ev-tooltip-img";
import { environment } from "src/environments/environment";
import { ExternalLinksService } from "src/services/externallinks.service";

@Component({
    selector: "search-filter-green-housing",
    imports: [FormField, EVToggleComponent, EvTooltipImgModule],
    templateUrl: "./search-filter-green-housing.component.html",
    styleUrl: "./search-filter-green-housing.component.scss",
})
export class SearchFilterGreenHousingComponent {
    private readonly externalLinksService = inject(ExternalLinksService);

    filterForm = input.required<FieldTree<GreenHousingFilterModel>>();

    showGreenHousingTooltip = false;
    EVToggleStyle = EVToggleStyle;
    greenEnergyTooltipImgUrl: string = `https://${environment.resourcesStorageAccountName}.blob.core.windows.net/energyresources/img-gronnbolig2.jpg`;
    greenHomeArticleUrl: string;

    constructor() {
        this.greenHomeArticleUrl = this.externalLinksService.getGreenHomeArticleUrl();
    }

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }

    toggleIsGreenHome(isSelected: boolean): void {
        this.filterForm().isGreenHome().value.set(!isSelected);

        this.filterForm()
            .greenHomeBasisTypes()
            .value.update((greenHomeBasisTypes: GreenHomeModel[]) => {
                return greenHomeBasisTypes.map((greenHomeBasisType) => {
                    return {
                        ...greenHomeBasisType,
                        selected: !isSelected,
                    };
                });
            });
    }

    toggleSelectedGreenHome(greenHome: GreenHomeModel): void {
        const current = this.filterForm().greenHomeBasisTypes().value();
        this.filterForm()
            .greenHomeBasisTypes()
            .value.set(current.map((e) => (e.index === greenHome.index ? { ...e, selected: !e.selected } : e)));
    }

    showGreenEnergy(event: Event) {
        event.stopPropagation();
        this.showGreenHousingTooltip = true;
    }

    hideGreenEnergy() {
        this.showGreenHousingTooltip = false;
    }
}
